import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Spin } from 'antd';
import styles from './RcoConteiner.module.scss';
import RsoForm from '../RsoForm/RsoForm';
import { setErrorRso } from '../../../store/actions/rsoImportActions';
import useRSODraft from '../../../../../queries/useRSODraft';
import FileViewContainer from '../../common/FileViewContainer/FileViewContainer';
import useRcoContainerEffect from '../../../hooks/useRcoContainerEffect';

const RcoConteiner = () => {
  const dispatch = useDispatch();

  const { errorRso, getFileRso, loadingFileRSO, file } = useSelector(
    (state) => state.rsoImportStore
  );

  const {
    data: draftRSO,
    isFetching: isRSODraftFetching,
    refetch,
  } = useRSODraft();

  const visibleFileContainer = getFileRso && !loadingFileRSO;
  const visibleForm = !loadingFileRSO && !getFileRso;

  const onCloseAlert = () => {
    dispatch(setErrorRso(null));
  };

  useRcoContainerEffect(draftRSO);

  return (
    <Spin spinning={isRSODraftFetching}>
      <div style={{ width: '100%' }}>
        {errorRso && (
          <Alert
            message={errorRso}
            type="warning"
            closable
            onClose={onCloseAlert}
          />
        )}

        {visibleForm && <RsoForm onClickFetch={refetch} />}

        {loadingFileRSO && (
          <div className={styles.spinFile}>
            <div className={styles.boxSpin}>
              <div className={styles.textFile}>
                Формироваание отчета на основании файла:
                <br /> {file?.name}
              </div>

              <Spin
                spinning={loadingFileRSO}
                size="large"
              />
              <div className={styles.spinText}>Обработка...</div>
            </div>
          </div>
        )}

        {visibleFileContainer && <FileViewContainer />}
      </div>
    </Spin>
  );
};

export default RcoConteiner;
